import { render, staticRenderFns } from "./ASwitch.vue?vue&type=template&id=48de6e0f"
import script from "./ASwitch.vue?vue&type=script&lang=js"
export * from "./ASwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports